import React from 'react'
import { Alert } from 'antd'
import {
  ContentPanel,
  ContentPanelHeader,
} from '../../../../components/panels/content'
import MembersTable from './members-table'
import AddMember from './add-member'
import EmbeddedHidden from '../../../../containers/embeded-hidden/embeded-hidden'

const MembersManagement = ({
  orgTeams,
  users,
  isLoadingUsers,
  removeMember = null,
  changeMemberAccessibility = null,
  changeUserOrgTeams = null,
  changeMemberRole = null,
  sendInvite = null,
  inviteError = '',
  warningsMessage = null,
  isLimitedToAddContributors = false,
  invites = [],
  isLoadingInvites = false,
  removeInvite = null,
  isSSOConfigured,
  page,
  onPageChanged,
  emailFilter,
  onFilterChanged,
  totalUsers,
  pageSize,
  membersSeeAllAssets,
  customRoles = [],
}) => {
  return (
    <ContentPanel>
      <ContentPanelHeader>Team members</ContentPanelHeader>
      {warningsMessage && (
        <Alert message={warningsMessage} type="warning" showIcon />
      )}
      <EmbeddedHidden>
        {!isSSOConfigured && (
          <AddMember
            sendInvite={sendInvite}
            readOnly={isLimitedToAddContributors}
            inviteError={inviteError}
            customRoles={customRoles}
          />
        )}
      </EmbeddedHidden>
      <MembersTable
        membersSeeAllAssets={membersSeeAllAssets}
        users={users}
        isLoadingUsers={isLoadingUsers}
        removeMember={removeMember}
        changeMemberAccessibility={changeMemberAccessibility}
        changeUserOrgTeams={changeUserOrgTeams}
        changeMemberRole={changeMemberRole}
        orgTeams={orgTeams}
        invites={invites}
        removeInvite={removeInvite}
        isLoadingInvites={isLoadingInvites}
        isSSOConfigured={isSSOConfigured}
        page={page}
        onPageChanged={onPageChanged}
        emailFilter={emailFilter}
        onFilterChanged={onFilterChanged}
        totalUsers={totalUsers}
        pageSize={pageSize}
      />
    </ContentPanel>
  )
}
export default MembersManagement
